module.exports = __webpack_public_path__ + "static/img/16.fabe23f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcco/16.png
// module id = Roz5
// module chunks = 0